import { render, staticRenderFns } from "./AddPermissionInbox.vue?vue&type=template&id=522c4730&"
import script from "./AddPermissionInbox.vue?vue&type=script&lang=js&"
export * from "./AddPermissionInbox.vue?vue&type=script&lang=js&"
import style0 from "./AddPermissionInbox.vue?vue&type=style&index=0&id=522c4730&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports